import { useCallback, useMemo } from 'react';

// Component
import { BgHeader } from 'scbk-shared-module/layout/top-header/BgHeader';
import { DesktopHeader } from 'scbk-shared-module/layout/top-header/DesktopHeader';
import { RoundHeader } from 'scbk-shared-module/layout/top-header/RoundHeader';
import { WhiteHeader } from 'scbk-shared-module/layout/top-header/WhiteHeader';

// hooks
import { deviceUtils, Envs, i18n, useEnvContext, useMenuStore } from 'scbk-services';
import { useGlobalPopupContext } from 'scbk-shared-module';

// types
import type { PageHeaderProps } from 'scbk-shared-module/layout/types/HeaderType';
import type { MenuItem } from 'scbk-shared-module/layout/types/MenuItem';

const PageHeader = ({
  title,
  onClose,
  onHistoryClick,
  subHeaderType = 'round',
  isScrolled = false,
  isBackBtn = true,
  isCloseBtn = true,
  titleProps,
  closeProps,
}: PageHeaderProps) => {
  const isDesktop = deviceUtils.isPC();

  const { getEnv } = useEnvContext();

  // menu store : 현재 환경별 xml로 읽어온다.
  const { siteMapTree, menuTree } = useMenuStore.getState();
  // 메뉴 object 정제
  const composeMenuItem = useCallback(
    (tree?: Record<string, any>): MenuItem[] => {
      if (!tree) return [];

      const isKo = i18n.language === 'ko';

      return Object.keys(tree)
        .filter((key) => {
          if (isKo) {
            return true;
          }

          // 영어 설정의 경우 영문 메뉴만 filter
          const menuInfo = tree[key];

          return menuInfo.fields?.useEn === 'Y' && menuInfo.fields?.engName;
        })
        .map((key) => {
          const menuInfo = tree[key];

          let menuName = menuInfo?.name ?? '';

          if (!isKo && menuInfo.fields?.useEn === 'Y' && menuInfo.fields?.engName) {
            menuName = menuInfo.fields?.engName;
            if (key === 'SVCSUP000') {
              menuName = 'Lost Report';
            }
          }

          return {
            id: key,
            label: menuName ?? '',
            href: menuInfo?.url ?? '',
            channel: [...(menuInfo?.channel ?? [])],
            subitems: composeMenuItem(menuInfo?.children),
          };
        });
    },
    [i18n.language],
  );

  // 인뱅 메뉴만
  const iBMenuItems = useMemo(() => {
    let tree = { ...siteMapTree['ROOT']?.children };

    if (getEnv() === Envs.LOCAL || getEnv() === Envs.DEV) {
      const sampleMenu = Object.values(menuTree['SAMPLE0000']?.children ?? {}).reduce(
        (acc, item) => {
          acc = { ...acc, ...item?.children };
          return acc;
        },
        {},
      );

      const SAMPLE0000 = {
        ...menuTree['SAMPLE0000'],
        children: { ...sampleMenu },
      };

      tree = { ...tree, SAMPLE0000 };
    }

    return composeMenuItem(tree);
  }, [siteMapTree['ROOT']?.children, i18n.language, getEnv]);

  const { openUserInfoPopup } = useGlobalPopupContext();

  return (
    <>
      {isDesktop ? (
        <DesktopHeader menuitems={iBMenuItems} isScrolled={isScrolled} />
      ) : (
        <>
          {subHeaderType === 'round' && (
            <RoundHeader
              title={title ?? ''}
              onClose={onClose}
              onHistoryClick={onHistoryClick}
              isScrolled={isScrolled}
              opacity={0}
              titleProps={titleProps}
              closeProps={closeProps}
              isBackBtn={isBackBtn}
              openUserInfoPopup={openUserInfoPopup}
            />
          )}
          {subHeaderType === 'white' && (
            <WhiteHeader
              title={title ?? ''}
              onHistoryClick={onHistoryClick}
              // onAlertPanel={onAlertPanel}
              // onSearchPanel={onSearchPanel}
              onClose={onClose}
              isScrolled={isScrolled}
              titleProps={titleProps}
              isBackBtn={isBackBtn}
              openUserInfoPopup={openUserInfoPopup}
            />
          )}
          {subHeaderType === 'bg' && (
            <BgHeader
              title={title ?? ''}
              onClose={onClose}
              isScrolled={isScrolled}
              titleProps={titleProps}
              closeProps={closeProps}
              openUserInfoPopup={openUserInfoPopup}
              isCloseBtn={isCloseBtn} //260723 추가
            />
          )}
        </>
      )}
    </>
  );
};

export { PageHeader };
